import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HttpResponsesHandlersFactory, IHttpResponseHandlerSettings} from "@bbwt/modules/data-service";
import {FormIODefinition} from "@features/bb-formio";
import {FormDefinitionParameters, FormTagsParameters} from "@features/bb-formio/dto/form-definition";
import {IPagedData, PagedCrudService} from "@features/grid";
import {PublishFormDTO} from "../dto/publishFormDTO";
import {EntityId} from "@bbwt/interfaces";
import {setFiltersUTCTimeZone} from "@mipro/classes/date-utils";
import {IQueryCommand} from "@features/filter";

@Injectable()
export class FormioViewerService extends PagedCrudService<FormIODefinition> {
    public readonly url = "api/formio";
    public readonly entityTitle = "Form definition";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    async copyForm(definitionId: string, name: string): Promise<boolean> {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/copy-form/${definitionId}`, null,
                {params: this.constructHttpParams({name: name})}), this.handlersFactory.getDefault());
    }

    getPage(queryCommand: IQueryCommand, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<IPagedData<FormIODefinition>> {
        setFiltersUTCTimeZone(queryCommand, "activeRevision.lastUpdatedOn");
        return super.getPage(queryCommand, responseHandlerSettings);
    }

    async getFormJson(id: string, readOnly: boolean, body: FormDefinitionParameters): Promise<FormIODefinition> {
        return await this.handleRequest<FormIODefinition>(
            this.http.post<FormIODefinition>(`${this.url}/form-definition/${id}/${readOnly}`, body),
            this.handlersFactory.getDefault()
        );
    }

    async publishForm(form: PublishFormDTO) {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/publish`, form),
            this.handlersFactory.getForUpdate("Form publishing", {
                successMessage: "The form has been published to the selected organisations."
            })
        );
    }

    async unarchive(id: EntityId): Promise<FormIODefinition> {
        return await this.handleRequest<FormIODefinition>(
            this.http.put<FormIODefinition>(`${this.url}/${id}/unarchive`, null),
            this.handlersFactory.getDefault()
        );
    }

    async updateFormTags(formioTagsService: FormTagsParameters): Promise<FormIODefinition> {
        return await this.handleRequest<FormIODefinition>(
            this.http.put<FormIODefinition>(`${this.url}/tags`, formioTagsService),
            this.handlersFactory.getDefault()
        );
    }

    async ChangeOwnership(form: number, user: string) {
        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/owner`, {newOwnerId: user, formDefinitionId: form}),
            this.handlersFactory.getForUpdate("Form ownership", {successMessage: "The form has changed ownership."})
        );
    }
}
